import React from 'react';
import Typography from './Typography';

const CustomInput = ({ label, value, onChange, type = 'text', placeholder, className = '' }) => {
  return (
    <div className={`flex flex-col items-start space-y-2 sm:w-[402px] ${className}`}>
      {label && (
        <label
          htmlFor={label}
          className="text-white text-left"
        >
          <Typography text={label} size={'12px'} weight={400} lineheight={'170%'} />
        </label>
      )}
      <div
        className="relative w-full h-[40px] flex items-center pl-3"
        style={{
          backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='402' height='40' viewBox='0 0 402 40' fill='none'><path d='M0 0L394.285 0L402 5.41667V40H0V0Z' fill='%23454545'/></svg>")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <input
          id={label}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ color: '#B7B7B7', }}
          className="w-full custom-input-text h-full bg-transparent text-[#B7B7B7] placeholder-[#B7B7B7] focus:outline-none"
        />
      </div>
    </div>
  );
};

export default CustomInput;
